import { render } from "./OtpVarification.vue?vue&type=template&id=33b4782a&scoped=true"
import script from "./OtpVarification.vue?vue&type=script&lang=js"
export * from "./OtpVarification.vue?vue&type=script&lang=js"

import "./OtpVarification.vue?vue&type=style&index=0&id=33b4782a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b4782a"]])

export default __exports__